import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Select from 'react-select'
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import { useUpdateUser } from "queries/users";
import SoftInput from "components/SoftInput";
import { useAgencyInfo } from "context/agency";
import { Icon, IconButton, InputAdornment } from "@mui/material";
import ReactSelect from "react-select";
import ModelPromptslabels from "../../../UiPrompts/promptlabels/ModelPrompts/Create"
import { Visibility, VisibilityOff } from "@mui/icons-material";

function ModalComponent({ open, onClose, accounts, data, handleRefresh, tagsoption }) {
  const request = useRequest();
  const queryClient = useQueryClient();
  const [agency] = useAgencyInfo();
  // Set activeLocation properly on load
  const [activeLocation, setActiveLocation] = useState(() => {
    // Check if `data?.activeLocation` exists and is not empty
    if (data?.activeLocation?.length) {
      // Map through the accounts and filter for those that match the activeLocation values
      return accounts
        .filter((account) => data.activeLocation.includes(account.value))
        .map((account) => ({
          label: account.label,
          value: account.value,
        }));
    }
    return [];
  });


  const [tags, setTags] = useState(data?.prompt_label_ids.map(option => option._id) || []);
  const [addTagModel, setAddTagModel] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChangeTags = (selectedOptions) => {
    setTags(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };

  useEffect(() => {
    if (data && data.activeLocation && Array.isArray(accounts)) {

      const matchedLocations = data.activeLocation
        .map((location) => {

          const matchedAccount = accounts.find(account => account.id === location);
          if (matchedAccount) {
            return {
              label: matchedAccount?.business_name,
              value: matchedAccount.id,
            };
          }
          return null;
        })
        .filter(location => location !== null);

      setActiveLocation(matchedLocations);
    }
  }, [data, accounts]);

  const { mutateAsync: updateUser } = useUpdateUser();

  // promptslabel is another fork's domain - inlined via useRequest().
  const { mutateAsync: createPromptLabel } = useMutation({
    mutationFn: (payload) => request(ReqMethods.POST, "/promptslabel/create", { payload, toaster: true }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["prompt-labels"] }),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWaiting(true);
    // Prepare payload with existing data if no changes are made to activeLocation
    const payload = {
      _id: data._id,
      userName: e.target.username.value,
      password: e.target.password.value,
      email: e.target.email.value,
      prompt_label_ids: tags,
      activeLocation: activeLocation.map(item => item?.value || item),
    };
    const { response } = await updateUser(payload);

    if (response) {
      onClose();
      setWaiting(false);
    }
  };

  const savedataPromptLabel = async (formData) => {
    const updatedFormData = {
      ...formData,
      agency_id: agency._id,
      type: "agency",
    };

    const { response } = await createPromptLabel(updatedFormData);
    if (response) {
      handleclose();
      setAddTagModel(false);
    }
  };

  const handleclose = () => {
    setAddTagModel(false);
  };

  const handleAddTag = () => {
    setAddTagModel(true);
  };

  const changeactivelocaion = (e) => {
    setActiveLocation(e);
  };

  return (
    <>
      {open && (
        <div className="modal-zz-confirm text-left">
          <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
            <h2 className="text-black text-left font-14">Update User </h2>
            <span className="crossison" onClick={onClose}>X</span>
            <SoftBox component="form" onSubmit={handleSubmit}>
              <SoftBox mb={1} sx={{ fontSize: "14px", fontWeight: "500" }}>
                <label className="text-black">Account</label>
                <Select
                  defaultValue={activeLocation}
                  isMulti={true}
                  onChange={(selectedOptions) => setActiveLocation(selectedOptions || [])}
                  name="account"
                  className="form-input w-full"
                  options={accounts.filter(item => item.business_name !== "Bevis").map((account) => ({
                    label: account?.business_name,
                    value: account.id,
                  }))}
                />
              </SoftBox>

              <SoftBox className="margin-top-10px">
                <SoftTypography className="text-black w-100 d-flex justify-content-between" variant="button" sx={{ fontSize: "14px", fontWeight: "500" }} mb={1}>
                  <label className="w-50 new_dezin_label text-black">Template Agents Name</label>
                  {/* <p className="w-50 text-right new_dezin_label text-black cursor-pointer" onClick={handleAddTag}>
                    + Add Tag
                  </p> */}
                </SoftTypography>
                <ReactSelect
                  name="tags"
                  className="form-input w-full"
                  options={Array.isArray(tagsoption) ? tagsoption.filter(item => item.api_type === 'user').map((item) => ({
                    label: item?.template?.templatename ? item?.template?.templatename : item?.name,
                    value: item._id,
                  })) : []}
                  defaultValue={Array.isArray(data.prompt_label_ids) ? data.prompt_label_ids.map((item) => ({
                    label: item?.template?.templatename ? item?.template?.templatename : item?.name,
                    value: item._id,
                  })) : []}
                  isMulti={true}
                  onChange={handleChangeTags}
                />
              </SoftBox>

              <SoftBox mb={1}>
                <label className="text-black">Name</label>
                <SoftInput
                  label="Name"
                  placeholder="Name"
                  defaultValue={data?.userName}
                  name="username"
                  fullWidth
                />
              </SoftBox>
              <SoftBox mb={1}>
                <label className="text-black">
                  Email
                </label>
                <SoftInput
                  label="Email"
                  placeholder="Email"
                  defaultValue={data?.email}
                  name="email"
                  fullWidth
                />
              </SoftBox>
              <SoftBox mb={1}>
                <label className="text-black">Password</label>
                <SoftInput
                  type={showPassword ? "text" : "password"} // Dynamically change input type
                  label="Password"
                  placeholder="Password"
                  defaultValue={data?.assign_password}
                  name="password"
                  fullWidth
                  endAdornment={
                    <InputAdornment style={{ position: "absolute", right: "0px" }}>
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                        onMouseDown={(e) => e.preventDefault()} // Prevent focus while holding the button
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </SoftBox>
              <SoftBox mt={4}>
                <button className="savebtn-setting w-100" color="dark" fullWidth disabled={waiting}>
                  {waiting && (
                    <div className="spinner" style={{
                      width: '16px',
                      height: '16px',
                      display: "inline-block",
                      marginRight: "8px"
                    }}></div>
                  )}
                  Update
                </button>
              </SoftBox>
            </SoftBox>
          </div>
        </div>
      )}
      {addTagModel && (
        <ModelPromptslabels data={null} modelfunctionality={savedataPromptLabel} openModel={addTagModel} onclosemodel={handleclose} />
      )}
    </>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accounts: PropTypes.array,
  data: PropTypes.object,
  handleRefresh: PropTypes.func,
  tagsoption: PropTypes.object
};

function Modal({ data, accounts, handleRefresh, tagsoption }) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <>
      <span
        style={{ margin: "0px 20px " }}
        className="cursor-pointer"
        onClick={() => setOpenAddMember(true)}
      >
        <Icon>edit</Icon>
      </span>
      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        accounts={accounts}
        data={data}
        handleRefresh={handleRefresh}
        tagsoption={tagsoption}
      />
    </>
  );
}
Modal.propTypes = {
  accounts: PropTypes.array,
  data: PropTypes.array,
  handleRefresh: PropTypes.func,
};
export default Modal;
